// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d6d96b49","239":"0c90998d","453":"acf40ea4","732":"70daabb9"}[chunkId] + ".chunk.js";
};